import type { AdUnit } from '../../Entities/AdUnit.entity';
import { PATH_BASE } from '../Constants';
import { DMPU_SIZE } from '../UnitSizes';

export const ReviewsLandingPageDMPU1 = {
  path: `${PATH_BASE}/DMPU1_UK`,
  sizes: [DMPU_SIZE],
  defaultHeight: DMPU_SIZE[1],
  minHeight: 250,
  responsiveSizeMap: {
    1440: [DMPU_SIZE],
    1280: [DMPU_SIZE],
    1024: [DMPU_SIZE],
    768: [],
    0: [],
  },
  useSizeMap: true,
  trackingData: {
    renderEvent: {
      name: 'UK_webapp_slot_render_ended',
      label: 'DMPU 1 UK banner is loaded',
    },
    impressionEvent: {
      name: 'UK_webapp_impression_viewable',
      label: 'DMPU 1 UK banner is loaded',
    },
  },
} as const satisfies AdUnit;
